import React from "react"

import TasksView_Column from "../../../../../model2/column/column"
import {
    AggregateFunctionLabel,
    AggregateFunctionType
} from "../../../../../data-structures/aggregators/types"
import AggregateShellComponent from "../../../../../gd-modules/common/aggregate/aggregate-shell"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldEstimate_AggregateCell"
const debug = false

export default function FieldEstimate_AggregateCell(props: Props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value)

    // Determine label to show when there is no data, depending on the aggregate function type
    let noDataLabel
    switch (props.column.aggregateFunction) {
        case AggregateFunctionType.SUM:
            noDataLabel = ''
            break

        default:
            noDataLabel = props.column.aggregateFunction
                ? AggregateFunctionLabel[props.column.aggregateFunction]
                : ''
            break
    }

    const valueLabel = isValid ? gd.utils.minutesHumanize(Math.round(props.value)) : ''

    // Get available aggregate function options for this field, if any
    const options = props.column.field?.getAggregateOptions()

    debug && console.log(debug, 'render', valueLabel, props.value)

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {valueLabel}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <>
                    <div className="aggregate-label">
                        {AggregateFunctionLabel[props.column.aggregateFunction!]}:
                    </div>
                    <div className="aggregate-value aggregate-number">
                        {valueLabel}
                    </div>
                </>}

            {!isValid &&
                <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    )
}
